import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import Welcome from './routes/Welcome';
import ClientData from './routes/ClientData';
import SkinMeasures from './routes/SkinMeasures';
import Preferences from './routes/Preferences';
import MyPerfume from './routes/MyPerfume';
import Mouillettes from './routes/Mouillettes';
import Result from './routes/Result';
import QrLanding from './routes/QrLanding';
import AdminHome from './routes/AdminHome';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <PwaInstallPrompt />
      <Routes>
      {/* App de la tablet (vendedor + cliente) */}
      <Route path="/" element={<Welcome />} />
      <Route path="/cliente" element={<ClientData />} />
      <Route path="/piel" element={<SkinMeasures />} />
      <Route path="/preferencias" element={<Preferences />} />
      <Route path="/mi-perfume" element={<MyPerfume />} />
      <Route path="/mouillettes" element={<Mouillettes />} />
      <Route path="/resultado" element={<Result />} />

      {/* Landing pública del QR (lo abre el cliente con su móvil) */}
      <Route path="/r/:id" element={<QrLanding />} />

      {/* Panel admin */}
      <Route path="/admin/*" element={<AdminHome />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
